import React from 'react';

type Props = {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
  style?: React.CSSProperties;
};

export function TranscriptionToggleButton({ isOpen, onClick, className, style }: Props) {
  return (
    <button
      className={className}
      style={{
        minWidth: '34px',
        height: '34px',
        padding: '0 7px 0 9px',
        borderRadius: '9px',
        border: '1px solid rgba(255,255,255,0.14)',
        backgroundColor: isOpen ? 'rgba(83, 123, 255, 0.2)' : 'rgba(255,255,255,0.08)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.18)',
        color: isOpen ? '#8fb2ff' : '#d5deef',
        transition: 'background-color 160ms ease, border-color 160ms ease, color 160ms ease',
        ...style,
      }}
      onClick={onClick}
      aria-label={isOpen ? 'Hide Transcript' : 'Show Transcript'}
      title="Transcription"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="18"
        height="18"
        fill="currentColor"
        style={{
          fontSize: '16px',
          width: '16px',
          height: '16px',
          flexShrink: 0,
        }}
      >
        <path d="M4 4h16v2H4zM4 8h10v2H4zM4 12h16v2H4zM4 16h10v2H4z" />
      </svg>
    </button>
  );
}
